import styled from '@emotion/styled';
import { Divider, Typography } from '@material-ui/core';
import { SPACING_MEDIUM } from '../../../constant/spacing';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

export const StyledPaper = styled('div')(`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #FFFFFF;
  box-shadow: 0px 1px 9px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin-top: 24px;
`);

export const PaperTitle = styled('div')(`
  width: 100%;
`);

export const PaperItem = styled('div')(`
  width: 100%;
  padding-top: 24px;
`);

export const PaperTitleText = styled(Typography)(`
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: ${COLOR_TEXT_MAIN};
`);

export const PaperContent = styled('div')(`
  width: 100%;
`);

export const PaperText = styled('div')(`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  white-space: pre-wrap;
  color: ${COLOR_TEXT_MAIN};
`);

export const PaperFooter = styled('div')(`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -8px;
`);

export const PaperDivider = styled(Divider)(`
  margin-top: 24px;
  margin-bottom: 16px;
`);

export const PaperContainer = styled('div')({
  padding: SPACING_MEDIUM,
  backgroundColor: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 1px 9px rgba(0, 0, 0, 0.04)',
  borderRadius: '8px',
});
